import moment from 'moment';
import React from 'react';
import { Card, Badge, NumberFormatter } from '@mantine/core';
import { BsWifi, BsSnow, BsCupHot } from 'react-icons/bs';

import { IHotelOnlineBookingList } from 'libs/data-access/types';
import { calculateDateForFreeCancellation, isDateAfter } from 'utils/utility';


// helper to pick up to 5 amenities (any, not just key ones)
const pickAmenities = (facilities: any[] = []) => {
    // optionally, map some names to icons
    const iconMap: Record<string, React.ReactNode> = {
        wifi: <BsWifi />,
        ac: <BsSnow />,
        air: <BsSnow />,
        breakfast: <BsCupHot />,
    };

    return facilities.slice(0, 5).map(facility => {
        // Try to find an icon for the amenity
        const lower = facility.name?.toLowerCase() || '';
        let icon = null;
        for (const key in iconMap) {
            if (lower.includes(key)) {
                icon = iconMap[key];
                break;
            }
        };
        return { name: facility.name, icon };
    });
};


const HotelRoomDetailsSimple = ({ hotel, showCarousel }: {
    hotel: IHotelOnlineBookingList['bookingRooms'];
    showCarousel: boolean;
}) => {
    return (
        <div className="space-y-8">
            {
                hotel?.map((room, idx) => {
                    const amenities = pickAmenities(room.hotelBookingFacilities);
                    const mainImage = room.roomImageUrl?.[0];
                    const price = room.roomRateKey?.totalPrice;

                    return (
                        <div
                            key={idx}
                            className={`text-sm bg-white/90 overflow-hidden ${(idx + 1) !== hotel.length ? "border-b border-gray-200" : ""}`}
                        >
                            {/* {showCarousel && room.roomImageUrl?.length > 1 ? (
                            <Carousel withIndicators loop height={220} className="w-full">
                                {room.roomImageUrl.map((img, i) => (
                                    <Carousel.Slide key={i}>
                                        <Image src={img} alt="Room image" fit="cover" height={220} radius={0} />
                                    </Carousel.Slide>
                                ))}
                            </Carousel>
                        ) : (
                            mainImage && <Image src={mainImage} alt="Room image" fit="cover" height={220} radius={0} />
                        )} */}
                            <div className="p-3">
                                <div className="flex items-center justify-between mb-2">
                                    <span className="font-semibold text-gray-800">{room.roomName} - {room.boardNameResponses?.[0]?.boardName}</span>
                                    {/* {typeof price === 'number' && (
                                        <span className="text-xl font-semibold text-blue-600">
                                            <NumberFormatter value={price} thousandSeparator prefix="₹ " />
                                        </span>
                                    )} */}
                                </div>

                                <div className="flex items-center gap-3 mb-3">
                                    {amenities.length > 0 ? amenities.map((am, i) => (
                                        <span
                                            key={i}
                                            className="capitalize text-xs"
                                        >{am.name}</span>
                                    )) : <span className="text-slate-400 text-sm">No amenities listed</span>}
                                </div>

                                {/* Rate Comment and Guests */}
                                <div className="flex flex-wrap items-center gap-4 mb-3">
                                    {room.roomRateKey?.rateComment && (
                                        <span className="text-sm text-slate-600 bg-slate-100 rounded px-2 py-1">
                                            {room.roomRateKey.rateComment}
                                        </span>
                                    )}
                                    {Array.isArray(room.guestList) && room.guestList.length > 0 && (
                                        <span
                                            className="text-sm text-slate-600"
                                        >
                                            Guests: {room.guestList.length}
                                        </span>
                                    )}
                                </div>

                                {/* Cancellation Policies Section */}
                                <div className="mb-4">
                                    <div className="mb-2 flex items-center">
                                        <span className="font-semibold">Cancellation Policies</span>
                                    </div>
                                    {room.roomRateKey.cancellationPolicies?.length > 0 ? (
                                        room.roomRateKey.cancellationPolicies?.map((policy, i) => (
                                            <div className="flex flex-col gap-3 mb-2" key={i + "_cancellation_policy"}>
                                                {isDateAfter(
                                                    moment().format("YYYY-MM-DDTHH:mm:ssZ"),
                                                    calculateDateForFreeCancellation(policy?.from)
                                                ) ? (
                                                    <Badge color="red" variant="light">Refund is Not Available</Badge>
                                                ) : null}
                                                {i === 0 ? (
                                                    <div className='flex items-center justify-between'>
                                                        <div className="text-green-600">
                                                            <span>Free until <span className="font-semibold text-sm">
                                                                {calculateDateForFreeCancellation(policy?.from)}
                                                            </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <div className="flex items-center justify-between text-red-600 text-sm">
                                                    <span>After <span className="fw-bold">
                                                        {calculateDateForFreeCancellation(policy?.from)}
                                                    </span>
                                                    </span>
                                                    <span className="">
                                                        <label className="font-semibold">Charges:</label>
                                                        {policy?.amount && <span>{" "}{<NumberFormatter
                                                            thousandSeparator
                                                            prefix="₹ "
                                                            value={policy?.amount || 0}
                                                        />}</span>}
                                                        {policy?.percent && <span>{policy?.percent}%</span>}
                                                        {policy?.numberOfNights && <span>{policy?.numberOfNights} Night</span>}
                                                    </span>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="h-25 flex items-center">
                                            <p className="text-slate-400 text-sm">Cancellation policy is not available to show for this room</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default HotelRoomDetailsSimple; 